import { useState, useEffect } from 'react';
// import { HomeOutlined } from '@ant-design/icons';
// import { Tooltip } from 'antd';
// import { FaLayerGroup } from 'react-icons/fa6';
// import { Modal } from 'antd';
// import React from 'react';
// import ReactDOM from 'react-dom';
// import OlOverlay from 'ol/Overlay';
// import OlLayerTile from 'ol/layer/Tile';
// import { Group } from 'ol/layer';
import './forest_data_map_layer_popover.css';

// import { Modal } from 'react-bootstrap';

const ForestDataMapLayer = (props) => {
  // const [openModal, setOpenModal] = useState(false);
  const [hover] = useState(false);

  // const toggleHover = () => {
  //   setHover(!hover);
  // };
  // const showModal = () => {
  //   setOpenModal(true);
  // };
  useEffect(() => {
    let map = props.map;
    if (map === undefined) {
      map = props.mapRef.current.getMap();
    }

    let layers = props.layers;
    if (!layers) return;
    layers.forEach((layer) => {
      if (layer.getProperties().name) {
        layer.setZIndex(999);
      } else {
        const layer_name = layer.getProperties().layer_name;
        if (!layer_name) {
          layer.setZIndex(0);
        } else if (layer_name.search('ITS:') != -1) {
          layer.setZIndex(9999);
        } else if (layer_name.search('boundary:') != -1) {
          layer.setZIndex(500);
        } else {
          layer.setZIndex(0);
        }
      }
    });
  }, [props.layers]);

  let rootStyle = props.style;
  if (rootStyle === undefined) {
    rootStyle = {
      position: 'absolute',
      top: '98px',
      left: '7px',
      padding: '1px 4px 1px 4px',
      borderRadius: '6px',
      backgroundColor: hover ? 'rgba(0, 60, 136, .8)' : 'rgba(0, 60, 136, .5)',
      border: '3px solid rgba(255, 255, 255, 0.72)',
    };
  }

  return (
    <div>
      {/* <div
        style={rootStyle}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
      >
        <Tooltip title={'Reorder Map'} placement="right">
          <FaLayerGroup onClick={showModal} style={{ color: 'white' }} />
        </Tooltip>
      </div>
      <Modal title="Layer Organizer" open={openModal}></Modal> */}
    </div>
  );
};
export default ForestDataMapLayer;
